<template>
  <div class="info-main-menu-container" :class="componentStyle.header + '-header'">
    <h3
      v-for="(item, index) in items"
      :key="index"
      v-show="item.title"
      :class="[componentStyle.header + '-subtitle']"
    >
      <span
        v-if="item.children && Object.keys(item.children).length === 0"
        :class="[{ selected: item.id === +currentTheme }]"
        @click="itemThemeClicked(item)"
        >{{ item.title }}</span
      >
      <span
        v-if="item.children && Object.keys(item.children).length > 0"
        class="toggle-child"
        @click="itemToggled(index)"
        >{{ item.title }}
        <font-awesome-icon
          v-if="item.children && Object.keys(item.children).length > 0"
          icon="chevron-down"
          :class="['toggle-down', 'toggle-down-' + index]"
        />
        <font-awesome-icon
          icon="chevron-up"
          class="toggle-up hidden-toggle-up"
          :class="['toggle-up', 'toggle-up-' + index]"
        />
      </span>
      <button
        v-if="item.children"
        v-for="(child, i) in item.children"
        @click="itemThemeClicked(child)"
        :class="[
          'items-children-' + index,
          'btn btn-block text-left',
          { 'selected ': child.id === +currentTheme },
        ]"
        :key="i"
        v-show="child.title"
      >
        {{ child.title }}
      </button>
    </h3>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import Mixin from '../mixins/Mixin';

import HasPermission from '../directives/HasPermission.js';
export default {
  name: 'ItemList',
  mixins: [Mixin],
  directives: {
    HasPermission,
  },
  computed: {
    ...mapGetters({
      items: 'themes/getAllThemes',
      currentTheme: 'videos/getCurrentTheme',
      currentCategory: 'videos/getCurrentCategory',
      keyword: 'videos/getKeyword',
      live: 'live/getLive',
      isFullWidth: 'layout/isFullWidth',
      isSideNav: 'layout/isSideNav',
      currentLogo: 'layout/getCurrentLogo',
      componentStyle: 'layout/getComponentStyle',
      isHeaderInfo: 'layout/isHeaderInfo',
    }),
  },
    watch:{
      items(items){
          if(items && items.length > 0){
              const themeId = this.$route.params.themeId;
              if (themeId > 0 && this.isHeaderInfo) {
                  let currentTheme=  items.filter(theme=>theme.id===parseInt(themeId))
                  if(currentTheme && currentTheme.length >0){
                      this.setNbVideosByTheme(currentTheme[0].nbVideos);
                  }
              }
          }
      }
    },
  methods: {
    ...mapActions('videos', ['setKeyword', 'setCurrentCategory']),
    ...mapActions('themes', ['fetchThemes','setNbVideosByTheme']),
     async  itemThemeClicked(item){
        await this.setNbVideosByTheme(item.nbVideos)
        await this.itemClicked(item.id)
      },
    itemToggled(index) {
      document.querySelectorAll('.items-children-' + index).forEach(child => {
        child.classList.toggle('hidden-items-child');
      });
      document.querySelector('.toggle-down-' + index).classList.toggle('hidden-items-child');
      document.querySelector('.toggle-up-' + index).classList.toggle('show-items-child');
    },
  },
  created() {},
  mounted() {},
};
</script>

<style scoped lang="scss">
@import '../assets/scss/_variables.scss';
@import 'src/assets/scss/logo';

.info-main-menu-container {
  margin: 1em 0;
  &.info-header {
    /*color: var(--primary-color);*/
    font-size: 1.2em;
    text-align: left;
    .info-subtitle {
      font-size: 0.9em;
      margin-bottom: 1em;
      cursor: pointer;
      .toggle-child {
        display: flex;
        flex-direction: row;
        align-items: center;
        .toggle-down,
        .toggle-up {
          padding-left: 5px;
          width: 1.1em;
        }
      }
      button,
      span {
        font-size: 0.8em;
        &:not(.btn-link):hover,
        &:focus {
          text-decoration: none;
          color: var(--secondary-color) !important;
          box-shadow: none;
        }
        &.selected {
          color: var(--secondary-color) !important;
          box-shadow: none;
        }
      }
    }
  }
}

.hidden-items-child,
.hidden-toggle-up {
  display: none;
}
.show-items-child {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/ItemsList.vue